import { createAction, props } from '@ngrx/store';

export const setAssignedToMeFilter = createAction(
    '[POSTED GROUPED DOCUMENTS COMPONENT] Set Assigned To Me Filter',
    props<{ assignedToMeFilter: boolean }>()
);
export const setPostedByCandidatedFilter = createAction(
    '[POSTED GROUPED DOCUMENTS COMPONENT] Set Posted By Candidate Filter',
    props<{ postedByCandidateFilter: boolean }>()
);
export const setPostedByVendorFilter = createAction(
    '[POSTED GROUPED DOCUMENTS COMPONENT] Set Posted By Vendor Filter',
    props<{ postedByVendorFilter: boolean }>()
);
export const setLargeDocsOnlyFilter = createAction(
    '[POSTED GROUPED DOCUMENTS COMPONENT] Set Large Docs Only Filter',
    props<{ largeDocsOnlyFilter: boolean }>()
);
